<template>
    <div>
        <div class="top">
            <div class="topleft">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item :to="{ path: '/home' }">{{$t('home')}}</el-breadcrumb-item>
                    <el-breadcrumb-item>{{$t('loggl')}}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <div class="topright">
                <!-- <el-link type="primary" @click="showpop=true;status=1">+添加分类</el-link> -->
            </div>
        </div>
        <div class="cont">
            <div class="search">
                <div class="searchleft">
                    <el-form :inline="true" :model="searchform" class="demo-form-inline">
                        <el-form-item :label="$t('time')">
                            <el-date-picker
                            v-model="value1"
                            type="datetimerange"
                            size="small"
                            range-separator="至"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item>
                            <el-button size="small" type="primary" @click="onSubmit">{{$t('query')}}</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            <div class="mylist" v-loading="loading">
                <el-table
                :data="list"
                :header-cell-style="{'background':'#f5f5f5','font-weight':'bold','color':'#555555','padding':'6px 0'}"
                stripe
                border
                ref="myTable"
                style="width: 100%">
                    <el-table-column
                    prop="username"
                    width="220"
                    :label="$t('yonghum')">
                    </el-table-column>
                    <el-table-column
                    prop="description"
                    :label="$t('operator')">
                    </el-table-column>
                    <el-table-column
                    prop="logType"
                    :label="$t('jieguo')">
                    </el-table-column>
                    <el-table-column
                    prop="requestIp"
                    label="IP">
                    </el-table-column>
                    <el-table-column
                    prop="browser"
                    :label="$t('liulq')">
                    </el-table-column>
                    <el-table-column
                    prop="time"
                    :label="$t('shic')">
                    </el-table-column>
                    <el-table-column
                    prop="createTime"
                    :label="$t('createTime')">
                        <template slot-scope="scope">
                            {{scope.row.createTime | changedate}}
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="page">
                <app-page :total="total" :current="pageNo" :pageSize="pageSize" @handleCurrentChange="currentchange" @handleSizeChange="handchange"></app-page>
            </div>
        </div>
    </div>
</template>
<script>
import apiurl from "@/api/sys"
import _api from "@/api/index"
export default {
    data(){
        return{
            loading:false,
            searchform:{},
            value1:[],
            pageNo:1,
            pageSize:10,
            total:0,
            list:[],
        }
    },
    created(){
        this.getList()
    },
    methods:{
        getList(){
            this.loading=true
            _api.get(apiurl.logs,{page:this.pageNo,size:this.pageSize,createTime:this.value1}).then(res=>{
                this.loading=false
                this.list=res.content
                this.total=res.totalElements
            })
        },
        onSubmit(){
            this.pageNo=1
            this.getList()
        },
        handchange(data){//分页Size变化
            this.pageSize=data
            this.pageNo=1
            this.getList()
        },
        currentchange(data){//当前页变化
            console.log(data)
            this.pageNo=data
            this.getList()
        },
    }
}
</script>